/** 釘住背景 */
export const disableScroll = () => {
    document.body.style.overflow = 'hidden';
    document.body.style.display = 'block';
};

/** 取消釘住背景 */
export const enableScroll = () => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('display');
};
